import { proxy } from 'valtio';
import { DropMaterialsStateType } from 'basics/types/maya.types';

const dropMaterials = proxy<DropMaterialsStateType>({
  dropMaterials: [],
  isLoaded: false,
});

export default dropMaterials;
